import { createFileRoute, Outlet } from '@tanstack/react-router'
import { isAuthenticated, redirectToAuth } from '@/lib/auth'

export const Route = createFileRoute('/onboarding')({
	beforeLoad: async () => {
		if (!isAuthenticated()) await redirectToAuth()
	},
	component: () => <Outlet />,
})
